import { Dropdown, TextField } from '@statsbomb/kitbag-components';
import { useAtom } from 'jotai';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { selectedSourceDataAtom } from '../../../atoms/selectedSourceData';
import { getSourceOptions, getVideoSourceNames } from '../sourceOptions';

const filterByLegacySourceName = (option) => !option.isLegacySourceName;

export function SelectSourceName({ size, sport }) {
  const intl = useIntl();
  const [sourceData, setSourceData] = useAtom(selectedSourceDataAtom);

  const sourceNamesForSelectedSoureType = getSourceOptions(intl).find(
    (option) => option.value.sourceType === sourceData?.sourceType,
  )?.value.sourceNames;

  const handleSourceNameChangeTextfield = ({ target }) => {
    setSourceData({
      ...sourceData,
      isLicensed: false,
      sourceName: target.value,
    });
  };
  const handleSourceNameChangeDropdown = (selectedName) => {
    setSourceData({
      ...sourceData,
      isLicensed: selectedName.value.isLicensed,
      sourceName: selectedName.value.id,
    });
  };

  return sourceNamesForSelectedSoureType !==
    getVideoSourceNames(intl).FREEFORM ? (
    <Dropdown
      id="display-provide-source-name-dropdown"
      isDisabled={!sourceData?.sourceType}
      label={intl.formatMessage({
        defaultMessage: 'Source Name',
        id: '9d58d',
      })}
      labelPosition="top"
      onChange={handleSourceNameChangeDropdown}
      options={sourceNamesForSelectedSoureType?.filter(
        (option) =>
          filterByLegacySourceName(option) &&
          (!option.sport || option.sport === sport),
      )}
      placeholder={intl.formatMessage({
        defaultMessage: 'Select Video Source',
        id: '5704e',
      })}
      size={size}
      value={sourceNamesForSelectedSoureType?.find(
        (option) => option.value.id === sourceData.sourceName,
      )}
      variant="secondary"
    />
  ) : (
    <TextField
      id="display-provide-source-name-textfield"
      isDisabled={!sourceData?.sourceType}
      label={intl.formatMessage({
        defaultMessage: 'Source Name',
        id: '9d58d',
      })}
      onChange={handleSourceNameChangeTextfield}
      size={size}
      value={sourceData?.sourceName}
      variant="secondary"
    />
  );
}
SelectSourceName.propTypes = {
  size: PropTypes.string,
  sport: PropTypes.string.isRequired,
};

SelectSourceName.defaultProps = {
  size: undefined,
};

export default { SelectSourceName };
